import { runInAction } from "mobx";
import {
  AddProductVoiceController,
  type VoiceStatePatch,
  type VoiceStateSnapshot,
} from "./voice-controller";

export interface AddProductVoiceBindingState {
  isVoiceSupported: boolean;
  isVoicePanelOpen: boolean;
  isVoiceListening: boolean;
  isVoiceApplying: boolean;
  isSubmitting: boolean;
  voiceTranscript: string;
  voiceError: string | null;
  voiceInfo: string | null;
}

export function createAddProductVoiceController(input: {
  state: AddProductVoiceBindingState;
}): AddProductVoiceController {
  return new AddProductVoiceController({
    getState: (): VoiceStateSnapshot => ({
      isVoiceSupported: input.state.isVoiceSupported,
      isVoicePanelOpen: input.state.isVoicePanelOpen,
      isVoiceListening: input.state.isVoiceListening,
      isVoiceApplying: input.state.isVoiceApplying,
      isSubmitting: input.state.isSubmitting,
      voiceTranscript: input.state.voiceTranscript,
    }),
    setState: (patch: VoiceStatePatch): void => {
      runInAction(() => {
        if (typeof patch.isVoiceSupported === "boolean") {
          input.state.isVoiceSupported = patch.isVoiceSupported;
        }
        if (typeof patch.isVoicePanelOpen === "boolean") {
          input.state.isVoicePanelOpen = patch.isVoicePanelOpen;
        }
        if (typeof patch.isVoiceListening === "boolean") {
          input.state.isVoiceListening = patch.isVoiceListening;
        }
        if (typeof patch.voiceTranscript === "string") {
          input.state.voiceTranscript = patch.voiceTranscript;
        }
        if ("voiceError" in patch) {
          input.state.voiceError = patch.voiceError ?? null;
        }
        if ("voiceInfo" in patch) {
          input.state.voiceInfo = patch.voiceInfo ?? null;
        }
      });
    },
    appendTranscript: (transcript: string): void => {
      runInAction(() => {
        input.state.voiceTranscript = [
          input.state.voiceTranscript.trim(),
          transcript,
        ]
          .filter((chunk) => !!chunk)
          .join(" ")
          .trim();
      });
    },
  });
}
